import { useNavigate } from "react-router";
import { OrgCategory } from "../../generated/core-api";
import { useAuthenticated } from "../../authn";
import { OrgCreateForm } from "../components/Org/OrgCreateForm";
import { OrgCategoryView } from "../components/Org/OrgCategoryView";
import { useOrgCategoryParams, usePermissions } from "../hooks";
import { UnauthorizedMessage } from "../../shared/components";

export function OrgCreateScreen() {
  const authCtx = useAuthenticated();
  const { category } = useOrgCategoryParams();
  const navigate = useNavigate();
  const { isProvisioner } = usePermissions();

  // Only provisioners can create non-personal orgs
  if (!isProvisioner() && category !== "personal") {
    return <UnauthorizedMessage backLabel="< Knowledge Bases" />;
  }

  return (
    <OrgCategoryView title="Create Organisation" category={category}>
      {(categoryValue) => (
        <OrgCreateForm
          userId={authCtx.userId}
          category={categoryValue as OrgCategory}
          onSuccess={() => navigate("/org")}
        />
      )}
    </OrgCategoryView>
  );
}
